<template>
    <Popper placement="right" :show="isOpened">
        <i role="button" style="display:block; margin: 0 auto;" class="btn" :data-tid="`changeMod${task.id}`" @click="openPopper">
            <img src="../assets/change.svg" alt="">
        </i>
        <template #content>
            <div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <div class="fw-bold text-primary">
                    Przepinka dla: {{ task.numer_Przejazdu }}
                  </div>
                  <button class="btn btn-sm btn-danger" @click="closePopper">
                    Zamknij edytor <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div class="form-floating">
                    <input type="text" class="form-control" id="coOrdinatesInput" placeholder="50.123N50.123E" v-model="changecoOrdinates">
                    <label for="coOrdinatesInput">Np. 52.4067, 16.8430</label>
                </div>
                <span style="font-size:12px">np. 50.123, 8.123</span>
                <div class="input-group mt-3">
                    <span class="input-group-text">data i godzina</span>
                    <input type="datetime-local" class="form-control" id="timeInput" v-model="changeTime">
                </div>
                <div class="mt-3">
                    <input type="text" placeholder="ciągnik" class="form-control" v-model="changeVehicleInput" @input="fetchVehicles()">
                    <select name="vehicleSelect" id="vehicleSelect" class="form-control" v-model="changeVehicle" ref="changeVehicleSelect" @change="setDefaultDriver">
                      <option v-for="(vehicle, index) in filteredVehicles.length === 0 ? vehicles : filteredVehicles" :key="index" :value="vehicle.id">
                        {{ vehicle.plateNumber }}
                      </option>
                    </select>
                </div>
                <div class="my-2">
                    <label for="driverInput">po wybraniu ciągnika, <br> kierowcy zaczytają się automatycznie</label>
                    <div class="input-group">
                        <input type="text" placeholder="kierowcy" class="form-control" name="driverInput" id="driverInput" v-model="driverInput">
                        <button type="button" class="btn btn-success" @click="fetchDrivers">szukaj</button>
                    </div>
                    <select name="driverSelect" id="driverSelect" class="form-control" ref="driverSelect" v-model="driverSelect" @change="attachDriver()"></select>
                    <ul class="list-group drivers-list" ref="changeDrivers"></ul>
                </div>
                <div>
                    <button class="btn btn-primary btn-sm me-1" @click="resetForm">Reset</button>
                    <button class="btn btn-success btn-sm ms-1" @click="submitChange">Zatwierdź</button>
                </div>
            </div>
        </template>
    </Popper>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Popper from 'vue3-popper';
import emitter from '@/modules/events/emitter'
import { mapGetters } from 'vuex'
import { $axios } from '@/modules/http/axios'
import { validateDateTime } from '@/modules/change/changeDateTimeValidator'

export default {
  name: 'AddChange',
  props: ['task'],
  components:{Popper},

  data () {
    return {
      changecoOrdinates:'',
      changeTime:'',
      changeVehicle:'',
      changeVehicleInput:'',
      driverInput:'',
      driverSelect:'',
      currentId: '',
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      dataToPut:{
          trasa: '',
          postoje: []
      },
      filteredVehicles: [],
      isOpened: false
    }
  },
  computed: {
    ...mapGetters({
      vehicles: 'getChangeEditorVehicles'
    })
  },
  created () {
    emitter.on('changeEditorOpened', e => {
      if (e.taskId !== this.task.id) {
        this.isOpened = false
      }
    })
  },
  methods: {
    fetchData () {
      this.$store.dispatch('fetchChangeEditorVehicles')
    },
    async submitChange() {
      let validatorData = validateDateTime(this.changeTime, this.task, true)

      if (this.changeTime === '' || this.changecoOrdinates === '' || this.changeVehicle === '' || this.$refs.changeDrivers.querySelectorAll('li').length === 0) {
        await Swal.fire('Proszę uzupełnić wszystkie pola', 'Każde pole w edytorze Przepinki musi zostać uzupełnione', 'error')
      } else if (!this.changecoOrdinates.includes(',') && !this.changecoOrdinates.includes('N')) {
        await Swal.fire('Proszę rozdzielić współrzędne przecinkiem lub znakiem "N"', 'Pole współrzędnych musi zawierać dwie współrzędne rozdzielone przecinkiem lub znakiem "N"', 'error')
      } else if (!validatorData.isValid) {
        await Swal.fire(validatorData.errorMessage, '', 'error')
      } else {
        let latitude = ''
        let longitude = ''
        let driversIds = []

        latitude = this.changecoOrdinates.split(',')[0].trim()
        longitude = this.changecoOrdinates.split(',')[1].trim()

        this.$refs.changeDrivers.querySelectorAll('li').forEach(x => {
            driversIds.push(Number(x.dataset.did))
        })

        const postData = {
            acronym: `P${Number(this.changeVehicle)}`,
            latitude: latitude,
            longitude: longitude,
            date: `${this.changeTime}:00.000Z`,
            vehicleId: Number(this.changeVehicle),
            driverIds: driversIds
        }

        try {
          const response = (await $axios.post(`${this.task.id}/Changes`, postData)).data
          await Swal.fire(`Dodano Przepinkę do Zlecenia ${this.task.numer_Przejazdu}`, '', 'success')

          emitter.emit('taskChanged', { taskId: this.task.id })
          if (response.relatedTaskId) { emitter.emit('taskChanged', { taskId: response.relatedTaskId }) }
          this.resetForm()
        } catch (e) {
          if (e.response?.status && e.response.status !== 500) {
            await Swal.fire('Nie udało się dodać Przepinki', `System nie był w stanie dodać przepinki do zlecenia ${this.task.numer_Przejazdu}. <br> <span class="fw-bold">Kod błędu: ${e.response.status}</span>`, 'error')
          } else {
            emitter.emit('taskChanged', { taskId: this.task.id })
          }
        } finally {
          this.isOpened = false
        }
      }
    },
    sortDatesFn(arr){
        if(arr.length > 1){
            let times = []
            arr.forEach(a => {
            let splittedAarrival = a.przyjazd.split('')
            let arrArrivalYear = `${splittedAarrival[0]}${splittedAarrival[1]}${splittedAarrival[2]}${splittedAarrival[3]}`
            let arrArrivalMonth = `${splittedAarrival[5]}${splittedAarrival[6]}`
            let arrArrivalDay = `${splittedAarrival[8]}${splittedAarrival[9]}`
            let arrArrivalHour = `${splittedAarrival[11]}${splittedAarrival[12]}`
            let arrArrivalMin = `${splittedAarrival[14]}${splittedAarrival[15]}`
            times.push(`${this.months[arrArrivalMonth - 1]} ${arrArrivalDay} ${arrArrivalYear} ${arrArrivalHour}:${arrArrivalMin}`)
            })
            for (const x in arr) {
            arr[x].przyjazd = new Date(times[x])
            arr[x].przyjazd2 = arr[x].przyjazd
            }
            let sortedArr = arr.sort((a,b) => a.przyjazd2 - b.przyjazd2)
            return sortedArr;
        }else{
            return arr;
        }
    },
    fetchVehicles(){
        this.filteredVehicles = this.vehicles.filter(v => v.plateNumber.toLowerCase().includes(this.changeVehicleInput.toLowerCase()))
    },
    fetchDrivers(){
        this.$refs.driverSelect.innerHTML = '<option>kierowcy</option>'
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
        axios.get(`${process.env.VUE_APP_API_BASE_URL}Driver`, config)
            .then(re => {
                re.data.forEach(a => {
                    if(a.firstName == null){
                        a.firstName = ""
                    }
                    if(a.surname == null){
                        a.surname = ""
                    }
                    if(`${a.firstName.toUpperCase()} ${a.surname.toUpperCase()}`.includes(this.driverInput.toUpperCase()) || `${a.surname.toUpperCase()} ${a.firstName.toUpperCase()}`.includes(this.driverInput.toUpperCase())){
                        this.$refs.driverSelect.innerHTML = `${this.$refs.driverSelect.innerHTML}<option value="${a.firstName} ${a.surname}|${a.id}">${a.firstName} ${a.surname}</option>`
                    }
                })
            })
            .catch(er => {
                console.log(er);
            })
    },
    attachDriver(){
        this.$refs.changeDrivers.innerHTML = `${this.$refs.changeDrivers.innerHTML}<li class="list-group-item" onclick="remove()" data-did="${this.driverSelect.split('|')[1]}">${this.driverSelect.split('|')[0]}</li>`
    },
    resetForm(){
        this.changeTime = ''
        this.changecoOrdinates = ''
        this.changeVehicleInput = ''
        this.driverInput = ''
        this.$refs.changeDrivers.innerHTML = ''
        this.$refs.driverSelect.innerHTML = ''
    },
    setDefaultDriver(){
        this.$refs.changeDrivers.innerHTML = ''
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
        axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.changeVehicle}`, config)
            .then(res => {
                if(res.data.drivers.length > 0){
                    res.data.drivers.forEach(x => {
                        this.$refs.changeDrivers.innerHTML = `${this.$refs.changeDrivers.innerHTML}<li class="list-group-item" onclick="this.remove()" data-did="${x.id}">${x.firstName} ${x.surname}</li>`
                    })
                }
            })
    },

    closePopper () {
      this.isOpened = false
    },

    openPopper () {
      this.fetchData()
      emitter.emit('changeEditorOpened', { taskId: this.task.id })
      this.isOpened = true
    },

    remove () {
      this.$refs.changeDrivers.innerHTML = ''
    }
  }
}
</script>

<style>
.drivers-list > li:hover{
    text-decoration: line-through;
    font-style: italic;
    cursor: pointer;
}
</style>
